import React from 'react'
import { WidgetContent, Divider, TextField } from '@duik/it'
import { ModalButton } from '../UI/ModalButton'
import CreateNewModal from '../UI/CreateNewModal'
import FormInputGroup from '../UI/FormInputGroup'
import { ContactInput, CreateNewContactProps } from './Types/types'
import { Formik, ErrorMessage } from 'formik'
import * as Yup from 'yup'

const CreateNewContact: React.FC<CreateNewContactProps> = ({
  createNewContactModalToggle,
  createContact
}) => {
  const createNewContact = (values: ContactInput) => {
    createContact(values)
    createNewContactModalToggle()
  }

  return (
    <CreateNewModal title="Create New Contact" handleCloseModal={createNewContactModalToggle}>
      <Formik
        initialValues={{
          firstName: '',
          lastName: '',
          email: '',
          phoneNumber: '',
          company: '',
          title: ''
        }}
        validationSchema={ContactSchema}
        onSubmit={values => {
          createNewContact(values)
        }}
        render={({ values, handleBlur, handleChange, handleSubmit, isSubmitting }) => (
          <form onSubmit={handleSubmit}>
            <WidgetContent>
              <FormInputGroup>
                <FormInputGroup direction="horizontal">
                  <div>
                    <TextField
                      className="halfWidthInputBox"
                      label="First Name"
                      name="firstName"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.firstName}
                    />
                    <ErrorMessage
                      name="firstName"
                      render={msg => (
                        <span
                          style={{
                            position: 'absolute',
                            color: '#E6492D',
                            fontSize: '0.75rem'
                          }}
                        >
                          {msg}
                        </span>
                      )}
                    />
                  </div>
                  <div>
                    <TextField
                      className="halfWidthInputBox"
                      label="Last Name"
                      name="lastName"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.lastName}
                    />
                    <ErrorMessage
                      name="lastName"
                      render={msg => (
                        <span
                          style={{
                            position: 'absolute',
                            color: '#E6492D',
                            fontSize: '0.75rem'
                          }}
                        >
                          {msg}
                        </span>
                      )}
                    />
                  </div>
                </FormInputGroup>
                <FormInputGroup direction="horizontal">
                  <div style={{ marginTop: '16px' }}>
                    <TextField
                      className="halfWidthInputBox"
                      label="E-mail Address"
                      name="email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                    />
                    <ErrorMessage
                      name="email"
                      render={msg => (
                        <span
                          style={{
                            position: 'absolute',
                            color: '#E6492D',
                            fontSize: '0.75rem'
                          }}
                        >
                          {msg}
                        </span>
                      )}
                    />
                  </div>
                  <div style={{ marginTop: '16px' }}>
                    <TextField
                      className="halfWidthInputBox"
                      label="Phone Number"
                      name="phoneNumber"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.phoneNumber}
                    />
                    <ErrorMessage
                      name="phoneNumber"
                      render={msg => (
                        <span
                          style={{
                            position: 'absolute',
                            color: '#E6492D',
                            fontSize: '0.75rem'
                          }}
                        >
                          {msg}
                        </span>
                      )}
                    />
                  </div>
                </FormInputGroup>
                <p
                  style={{
                    color: '#289C91',
                    fontSize: '12px',
                    fontWeight: 500,
                    alignSelf: 'flex-end'
                  }}
                >
                  {/* + Add Number */}
                </p>
              </FormInputGroup>
            </WidgetContent>
            <Divider />
            <WidgetContent style={{ backgroundColor: '#FBFBFD', paddingBottom: '32px' }}>
              <FormInputGroup>
                <FormInputGroup direction="horizontal">
                  <div>
                    <TextField
                      className="fullWidthInputBox"
                      label="Company"
                      name="company"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.company}
                    />
                    <ErrorMessage
                      name="company"
                      render={msg => (
                        <span
                          style={{
                            position: 'absolute',
                            color: '#E6492D',
                            fontSize: '0.75rem'
                          }}
                        >
                          {msg}
                        </span>
                      )}
                    />
                  </div>
                </FormInputGroup>
                <FormInputGroup direction="horizontal">
                  <div style={{ marginTop: '16px' }}>
                    <TextField
                      className="fullWidthInputBox"
                      label="Title"
                      name="title"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.title}
                    />
                    <ErrorMessage
                      name="title"
                      render={msg => (
                        <span
                          style={{
                            position: 'absolute',
                            color: '#E6492D',
                            fontSize: '0.75rem'
                          }}
                        >
                          {msg}
                        </span>
                      )}
                    />
                  </div>
                </FormInputGroup>
              </FormInputGroup>
            </WidgetContent>
            <WidgetContent style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ width: '83px' }}>
                <ModalButton
                  buttonStyle="tertiary"
                  name="Cancel"
                  onClick={createNewContactModalToggle}
                />
              </div>
              <div style={{ width: '83px' }}>
                <ModalButton success type="submit" disabled={isSubmitting} name="Save" />
              </div>
            </WidgetContent>
          </form>
        )}
      />
    </CreateNewModal>
  )
}

export default CreateNewContact

const ContactSchema = Yup.object().shape({
  firstName: Yup.string()
    .min(2, 'Too Short!')
    .max(30, 'Too Long!')
    .required('Required'),
  lastName: Yup.string()
    .min(1, 'Too Short!')
    .max(30, 'Too Long!')
    .required('Required'),
  email: Yup.string()
    .email('Invalid email')
    .required('Required'),
  phoneNumber: Yup.string()
    .min(10, 'Too Short!')
    .max(10, 'Too Long!')
    .required('Required'),
  company: Yup.string()
    .min(2, 'Too Short!')
    .max(30, 'Too Long!')
    .required('Required'),
  title: Yup.string()
    .min(2, 'Too Short!')
    .max(30, 'Too Long!')
    .required('Required')
})
